export default __webpack_public_path__ + "static/flirting-b4d6d3dfa1fe5b7f914a04fed05cbcd2.svg";